<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            :label="displayName" 
            :prop="name"
            :rule="rules">
            <div style="width:100%">
                <el-button v-if="!showMode && subformCreate"
                    @click.stop="newItem"
                    size="default"
                    type="primary">
                    + {{ newName }}
                </el-button>
                <el-button v-if="!showMode && subformCreate"
                    size="default"
                    @click.stop="importByExcel"
                    plain>
                    <el-icon><download /></el-icon>{{ excelName }}
                </el-button>
                <el-button size="default"
                    @click.stop="exportByExcel" 
                    v-if="subformCreate">
                    <el-icon><upload /></el-icon> 导出
                </el-button>
                <el-button v-if="subformDelete && displayType === 0" 
                    size="default"
                    :disabled="selectItemIds.length === 0"
                    @click.stop="allDelete"
                    plain>
                    <el-icon><delete /></el-icon>
                    {{ batchDeleteName }}
                </el-button>
                <el-tooltip v-if="subformDelete && displayType === 0"  class="item" effect="dark" content="批量删除当前所选元素" placement="right">
                    <el-icon><info-filled /></el-icon>
                </el-tooltip>
            </div>
            
            <el-table v-if="displayType === 0"
                :data="(data[name] || {data:[]}).data"
                v-loading="loadingItems"
                min-height="400"
                max-height="500"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                    <el-table-column v-if="subformDelete"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column 
                        v-for="item in gridDefinition"
                        :key="item.Name"
                        show-overflow-tooltip
                        :prop = "item.Name"
                        :label = "item.Settings.ContentPartFieldSettings.DisplayName">
                        <template #default="scope" v-if="showLinkTemplate(item)">
                            <el-button @click.native.prevent="editLinkRow(scope.row[item.Name])"
                                    link
                                    type="primary"
                                    size="small">
                                    {{ item.Settings.LinkContentItemFieldSetting.ButtonName }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column 
                        v-if="isDisplayFlowInfo"
                        key="FlowState"
                        prop = "FlowState"
                        label = "流程信息">
                        <template #default="scope">
                            <el-button
                                :type="scope.row.FlowState == 1 ? 'success': 'primary'"
                                size="small">
                                {{ scope.row.FlowState == 1 ? "流程结束":"流程进行中" }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        v-if = "!disabled">
                        <template #default="scope">
                            <el-button @click.native.prevent="editRow(scope.row.ContentItemId)"
                                    link
                                    type="primary"
                                    size="small">
                                    {{ editName }}
                            </el-button>
                        </template>
                </el-table-column>
            </el-table>
            <div v-if="displayType === 1" class="linkQueryFieldCard">
                <el-card v-for="(item,index) in ((data[name] || {data:[]}).data)"
                    :key="index"
                    style="width:320px;display:inline-block;margin-right:2em"
                    class="box-card">
                    <template #header>
                        <div class="card-header">
                            <span class="header-span">{{ item[gridDefinition[0].Name] }} </span>
                            <el-button v-if="subformDelete" 
                                style="float: right; padding: 3px 0" 
                                type="primary" 
                                link 
                                @click.native.prevent="deleteRow(item)">
                                {{ deleteName }}
                            </el-button>
                            <el-button v-if="!disabled" 
                                style="float: right; padding: 3px 5px" 
                                link 
                                type="primary"
                                @click.native.prevent="editRow(item.ContentItemId)">
                                {{ editName }}
                            </el-button>
                        </div>
                    </template>
                    <div v-for="(definitionItem,index) in gridDefinition">
                        <div v-if="index !=0">
                            {{ definitionItem.Settings.ContentPartFieldSettings.DisplayName }} : {{ item[definitionItem.Name] }}
                        </div>
                    </div>
                </el-card>
            </div>
            <div v-if="displayType === 2">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ item["ContentItemId"] }} </span>
                    </div>
                    <div>
                        <div v-for="deFiitem in definition"></div>
                    </div>
                </el-card>
            </div>
            <el-pagination
                v-model:currentPage="currentpage"
                v-model:page-size="pagesize"
                :page-sizes="[20,50]"
                :background="true"
                layout="total, sizes, prev, pager, next, jumper"
                :total="(data[name] || {total:0}).total" />

            <el-dialog :title="excelName"
                destroy-on-close 
                append-to-body
                top="8vh" 
                width="60%"
                v-model="importState">
                <import-by-excel v-if="importState"
                                :fatchDataSource = "finishImport"
                                @init="initImport"
                                @closeimport="importState = false"
                                @finish = "finishImport"
                                :isSuperImport = "superImport"
                                :activities="superImportWorkflows"
                                :contentType = "requestContentType"
                                :parameters="importPassingParameter">
                </import-by-excel>
            </el-dialog>
            <el-dialog
                width="70%"
                @closed="getAllRow"
                top="0"
                class="qweFormDialog"
                :title="requestTitle"
                append-to-body 
                :close-on-click-modal="false"
                v-model="dialogVisible"
                destroy-on-close>
                <qweForm @operatorForm="formSubmit"
                        @initForm ="initForm"
                        v-if="dialogVisible"
                        :operation="requestOperation"
                        :passing-parameter="requestPassingParameter"
                        :content-type="requestContentType"
                        :content-item-id="requestContentItemId"
                        :flow-current-node-id ="requestFlowNodeId"
                        :node-ids ="requestNodeIds">
                        </qweForm>
            </el-dialog>

            <el-dialog v-model="exportItem.excelExportState" 
                class="import-dialog"
                destroy-on-close 
                title="导出" 
                top="10vh" 
                width="40%"
                append-to-body>
                <exportItem @cancel="exportItem.excelExportState = false"
                            @success = "exportItem.excelExportState = false"
                            :contentType="requestContentType"
                            :filter="exportItem.filter"
                            :orginalFilter="exportItem.orginaldataFilter"
                            :sort="exportItem.sort"
                            :displayName="displayName"
                            :exportFields="exportItem.exportFields"></exportItem>
            </el-dialog>
        </el-form-item>
    </el-col>
</template>

<style>
    .linkQueryFieldCard{
        padding-top: 12px;
    }
    .linkQueryFieldCard .el-card__header{
        padding-top: 6px;
        padding-bottom: 6px;
    }
    .linkQueryFieldCard .header-span{
        font-size: 1.27em;
        font-weight: bold;
    }
</style>

<script>
    import ImportItemVue from "../../Import/ImportItem.vue"
    import FormItemVue from "../../Form/FormItem.vue"
    import ExportItemVue from "../../Export/ExportItem.vue"
    import { InfoFilled, Download, Delete, Upload } from '@element-plus/icons-vue'

    import BaseLinkQueryField from "./BaseLinkQueryField"

    export default {
        name:"LinkQueryField",
        mixins:[BaseLinkQueryField],
        components:{
            "import-by-excel":ImportItemVue,
            "qweForm":FormItemVue,
            "download":Download,
            "info-filled":InfoFilled,
            "exportItem":ExportItemVue,
            "delete":Delete,
            "upload":Upload
        },
        methods:{
            showLinkTemplate(item){
                return item.FieldDefinition.Name == "LinkContentItemField"
            },

            editLinkRow:function(contentItemId){
                this.requestOperation = "Edit";
                this.requestContentItemId = contentItemId;
                this.requestPassingParameter = new Array();
                this.dialogVisible = true;
            }
        }
    }
    
</script>